import React, {Suspense} from "react";
import {Navigate, Route, Routes} from "react-router-dom";

const MainDemo = React.lazy(() => import("../views/home/MainDemo"));
const Work = React.lazy(() => import("../views/Work"));
const ProjectDetails = React.lazy(() => import("../views/portfolio/ProjectDetails"));
const About = React.lazy(() => import("../views/About"));
const Contact = React.lazy(() => import("../views/Contact"));

function Router() {
    return (
        <Suspense fallback={<div className="modern-loading">Loading</div>}>
            <Routes>
                <Route path="/" element={<MainDemo/>}/>
                <Route path="/portfolio" element={<Work/>}/>
                <Route path="/portfolio/:slug" element={<ProjectDetails/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/demo-2" element={<Navigate to="/" replace/>}/>
                <Route path="/demo-3" element={<Navigate to="/" replace/>}/>
                <Route path="/slider" element={<Navigate to="/portfolio" replace/>}/>
                <Route path="/slider-2" element={<Navigate to="/portfolio" replace/>}/>
                <Route path="/slider-3" element={<Navigate to="/portfolio" replace/>}/>
                <Route path="/portfolio-2" element={<Navigate to="/portfolio" replace/>}/>
                <Route path="/blog-details" element={<Navigate to="/portfolio" replace/>}/>
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Routes>
        </Suspense>
    );
}

export default React.memo(Router);
